<template>
    <div class="row" v-if="model">
        <div class="col" v-if="!inEdit"
        >
            <p :class="[{'text-italic': isNew}]">
                {{model.label}}
            </p>
        </div>

        <div class="col" v-else>
            <q-field label="Nazwa">
                <q-input
                    v-model="localLabel"
                    ref="editField"
                    :class="[{'text-italic': isNew}]"
                    @keyup.enter="save"
                    @keyup.esc="cancel"/>
            </q-field>
        </div>
        <div class="col-auto">
            <publish-button :model="model" what="activity"/>
            <q-btn flat round icon="edit" @click="toggleEdit"></q-btn>
            <q-btn flat round icon="delete" @click="confirmAndDelete"></q-btn>
        </div>
    </div>
</template>

<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import PublishButton from './pole/PublishButton'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QField from 'quasar-framework/src/components/field/QField'
    import QInput from 'quasar-framework/src/components/input/QInput'

    export default {
        name: 'ActivityEntry',
        props: ['model', 'isNew'],
        components: {QInput, QField, QBtn, PublishButton, QIcon},
        mounted () {
            if (this.model) {
                this.localLabel = this.model.label
            }
        },
        watch: {
            model (current) {
                if (current) {
                    this.localLabel = current.label
                }
            }
        },
        data () {
            return {
                inEdit: false,
                localLabel: '',
            }
        },
        methods: {
            toggleEdit () {
                this.inEdit = !this.inEdit

                if (this.inEdit) {
                    this.$nextTick(() => {
                        this.$refs.editField.focus()
                    })
                }
            },
            save () {
                const method = this.isNew ? 'create' : 'update'
                this.$store.dispatch(method, {
                    what: 'activity',
                    item: {
                        ...this.model,
                        label: this.localLabel
                    },
                    id: this.model.activityTypeId
                }).then(() => {
                    this.cancel()
                    this.$emit('saved')
                })
            },
            cancel () {
                this.inEdit = false
                this.localLabel = this.model.label
            },
            confirmAndDelete () {
                if (this.model.activityTypeId) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie aktywności`,
                        message: `Czy na pewno usunąć aktywność ${this.model.label}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {
                        this.$store.dispatch('remove', {
                            what: 'activity',
                            id: this.model.activityTypeId
                        })
                    }).catch(() => {

                    })
                } else {
                    this.$emit('delete');
                }
            },
        },
    }
</script>

<style scoped>

</style>